import PropTypes from 'prop-types'

import {useState} from 'react'

import {Gauge, gaugeClasses} from '@mui/x-charts/Gauge'
import {useSpring} from '@react-spring/web'

import './animatedScore.scss'

const AnimatedScore = ({referenceArcColor = '#EEEDED', value = 0}) => {
  const [displayValue, setDisplayValue] = useState(0)

  useSpring({
    from: {value: 0},
    to: {value},
    config: {duration: 1000},
    onChange: result => {
      setDisplayValue(Math.floor(result.value.value))
    }
  })

  return (
    <div className='animated-score'>
      <Gauge
        cornerRadius={50}
        innerRadius={'85%'}
        startAngle={-90}
        endAngle={90}
        sx={theme => ({
          [`& .${gaugeClasses.valueArc}`]: {
            fill: theme.palette.secondary.green
          },
          ['& text']: {
            fill: theme.palette.primary.main
          },
          [`& .${gaugeClasses.valueText}`]: {
            color: theme.palette.primary.main,
            fontSize: '3.5vw',
            fontWeight: '600',
            transform: 'translate(1px, -17%)'
          },
          [`& .${gaugeClasses.referenceArc}`]: {
            fill: referenceArcColor
          }
        })}
        text={`${displayValue}`}
        value={displayValue}
        valueMin={0}
        valueMax={500}
      />
      <div className='range'>
        <div className='min'>0</div>
        {
          value === 500 &&
          <div className='max-score-text'>Max score achieved!</div>
        }
        <div className='max'>500</div>
      </div>
    </div>
  )
}

AnimatedScore.propTypes = {
  referenceArcColor: PropTypes.string,
  value: PropTypes.number
}

export default AnimatedScore
